module.exports = {
    urlToObj:  (url)=>{
        var flashVars = {};
        var str = url;
        if (url.indexOf("?") != -1) {
            str = url.substr(url.indexOf("?") + 1);
        }
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            var key = strs[i].substr(0, strs[i].indexOf("="));
            var value = strs[i].substr(strs[i].indexOf("=") + 1);
            flashVars[key] = value;
        }
        return flashVars;
    },
    objectParseToString:  (value)=>{
        if (value == null) return "";
        var str = "";
        var count = 0;
        for (var item in value) {
            if (count > 0) {
                str += "&" + item + "=" + value[item];
            } else {
                str += item + "=" + value[item];
            }
            count++;
        }
        return str;
    }
}